import Typewriter from 'typewriter-effect'
import React from "react";
//import {BiDownload} from 'react-icons/bi'
//import ReactDOM from 'react-dom/client';
import "./Home.css";
import pdf from "./Abhishek_Jha_Resume.pdf"
import { ResumeLink } from '../ResumeLink';
import {AiFillLinkedin} from 'react-icons/ai';
import {AiFillTwitterSquare} from 'react-icons/ai';
import {AiFillGithub} from 'react-icons/ai'

const Home=()=>{
  return (

    <div id="home" >
      <div className="name">
        <div className='texti'> <h1 className='text-color'>Hi there </h1> </div>
       
        <div className='texti'><h1 className='text-color' id="user-detail-name" >I am Abhishek Jha</h1>
        </div>
		    
        <div>
        <h1 className='text-color'>
              <Typewriter
                className='auto-type'
                options={{
                  strings: [
                      "A Full Stack Web Developer.",
                      "A Problem Solver.",
                  ],
                   autoStart: true,
                  loop: true,
                  deleteSpeed: 80,
                }}
              />
          </h1>
        </div>
          
          <div id='ResButton' >

          <button id="resume-button-2" href={pdf} download onClick={ResumeLink} className='portButton' > <a href={pdf}  id="resume-link-2" download  > Resume </a></button>

          </div>



         <div className="contactlink">
          <div><a
              href="https://github.com/Abhishekjha1996"
              target="_blank"
              rel="noreferrer"
              id="contact-github"
            >
             
              <AiFillGithub className="contlink"/>
            </a></div>
          <div ><a
              href="https://www.linkedin.com/in/abhishekjha96/"
              target="_blank"
              rel="noreferrer"
            >
              <AiFillLinkedin className="contlink"/>
              
            </a></div>
            <div ><a
              href="https://twitter.com/ajha6667"
              target="_blank"
              rel="noreferrer"
            >
              <AiFillTwitterSquare className="contlink"/>
              
            </a></div>
          
            
          </div>



      </div>
      
      
      
      
      <div id='rightimg'>
        <img src={'https://media1.giphy.com/media/qgQUggAC3Pfv687qPC/200.webp?cid=ecf05e47o4hit66iql0yicpmif5vn4v3yto0vz6rss3686bw&rid=200.webp&ct=g'} alt="abhi" />
      </div>
    </div>
  );
}
export default Home;




// {/*       <button id="resume-button-2" className='portButton'>Resume<BiDownload className="download" onClick={ ResumeLink }/>
       
//         <a
//         id="resume-links-2"
//           href={pdf}
//           target="_blank"
//           rel="noreferrer"
//           download={"AbhiResume"}
//         >          
//         </a>
//         </button> */}